export const replaceTemplate = (
    template: string,
    replacements: Record<string, string | number>,
): string => {
    return template.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
        return replacements[key]?.toString() ?? match;
    });
};
